import { validateEmail } from "@/utils/emailValidation";

const MIN_USERNAME_LENGTH = 2;
const MIN_NAME_LENGTH = 2;
const MIN_PASSWORD_LENGTH = 8;

function hasText(value) {
  return String(value || "").trim().length > 0;
}

export function validateSignupForm(form, { requireCaptcha = true } = {}) {
  const errors = {};
  const username = String(form.username || "").trim();
  const name = String(form.name || "").trim();
  const mobile = String(form.mobile || "").trim().replace(/\s+/g, "");
  const password = form.password || "";
  const confirmPassword = form.confirm_password || "";

  if (!username) {
    errors.username = ["Please enter a username."];
  } else if (username.length < MIN_USERNAME_LENGTH) {
    errors.username = ["Your username needs at least 2 characters."];
  }

  if (!name) {
    errors.name = ["Please enter your name."];
  } else if (name.length < MIN_NAME_LENGTH) {
    errors.name = ["Your name needs at least 2 characters."];
  }

  const emailResult = validateEmail(form.email);
  if (!emailResult.valid) {
    errors.email = [emailResult.message];
  }

  if (!form.countrycode) {
    errors.mobile = ["Please select your country code from the dropdown."];
  } else if (!mobile) {
    errors.mobile = ["Please enter your phone number."];
  } else if (!/^\d{6,15}$/.test(mobile)) {
    errors.mobile = [
      "That phone number doesn't look right. Please enter 6 to 15 digits only.",
    ];
  }

  if (!form.gender) {
    errors.gender = ["Please choose your gender to continue."];
  }

  if (!password) {
    errors.password = ["Please create a password."];
  } else if (password.length < MIN_PASSWORD_LENGTH) {
    errors.password = ["Your password needs at least 8 characters."];
  }

  if (!confirmPassword) {
    errors.confirm_password = ["Please re-enter your password to confirm it."];
  } else if (password !== confirmPassword) {
    errors.confirm_password = [
      "The passwords you entered don't match. Please try again.",
    ];
  }

  if (requireCaptcha && !form.response) {
    errors.cfTurnstile = ["Please complete the security check."];
  }

  return {
    valid: Object.keys(errors).length === 0,
    errors,
    normalizedEmail: emailResult.valid ? emailResult.email : "",
  };
}

export function isSignupFormComplete(form, options) {
  return validateSignupForm(form, options).valid;
}

export { hasText };
